import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

import "./Skills.scss";

const Skills = () => {
	const [experiences, setExperiences] = useState([]);
	const [skills, setSkills] = useState([]);

	useEffect(() => {
		// const query = '*[_type == "experiences"]';
		// const skillsQuery = '*[_type == "skills"]';

		// client.fetch(query).then((data) => {
		// 	setExperiences(data);
		// });

		// client.fetch(skillsQuery).then((data) => {
		// 	setSkills(data);
		// });
	}, []);

	const skillSectionData = [
		{
			name:'ExpressJS',
			icon:'/skills/express.png'
		},
		{
			name:'Redux',
			icon:'/skills/redux.png'
		},
		{
			name:'React JS',
			icon:'/skills/react.png'
		},
		{
			name:'MongoDB',
			icon:'/skills/mongodb.png'
		},
		{
			name:'Sass',
			icon:'/skills/sass.png'
		},
		{
			name:'CSS3',
			icon:'/skills/css.png'
		},
		{
			name:'Javascript',
			icon:'/skills/javascript.png'
		},
		{
			name:'Material UI',
			icon:'/skills/mui.png'
		},
		{
			name:'Firebase',
			icon:'/skills/firebase.png'
		},
		{
			name:'Git',
			icon:'/skills/git.png'
		},
		{
			name:'Html5',
			icon:'/skills/html.png'
		},
		{
			name:'Node JS',
			icon:'/skills/nodejs.png'
		},
	]

	return (
		<>
			<h2 className="head-text">Skills & Experiences</h2>

			<div className="app__skills-container">
				{/* <motion.div className="app__skills-list">
					{skills.map((skill) => (
						<motion.div
							whileInView={{ opacity: [0, 1] }}
							transition={{ duration: 0.5 }}
							className="app__skills-item app__flex"
							key={skill.name}>
							<div
								className="app__flex"
								style={{ backgroundColor: skill.bgColor }}>
								<img src={urlFor(skill.icon)} alt={skill.name} />
							</div>
							<p className="p-text">{skill.name}</p>
						</motion.div>
					))}
				</motion.div> */}
				<motion.div className="app__skills-list">
					{
						skillSectionData.map((item,index) => (
							<motion.div
								whileInView={{ opacity: [0, 1] }}
								transition={{ duration: 0.5 }}
								className="app__skills-item app__flex"
								key={item?.name}>
								<div
									className="app__flex" style={{ backgroundColor: "#fef4f5" }}>
									<img src={item?.icon} alt={item?.name} />
								</div>
								<p className="p-text">{item?.name}</p>
							</motion.div>
						))
					}
				</motion.div>
				{/* <motion.div className="app__skills-list">
					<motion.div
						whileInView={{ opacity: [0, 1] }}
						transition={{ duration: 0.5 }}
						className="app__skills-item app__flex">
						<div
							className="app__flex" style={{ backgroundColor: "#fef4f5" }}>
							<img src={"https://cdn.sanity.io/images/401mjdck/production/91716227a0183f05eb4c2c846dda4ec6d3ea433c-480x480.png"} alt={"Redux"} />
						</div>
						<p className="p-text">Redux</p>
					</motion.div>
				</motion.div> */}
				<div className="app__skills-exp">
					{/* {experiences.map((experience) => (
						<motion.div className="app__skills-exp-item" key={experience.year}>
							<div className="app__skills-exp-year">
								<p className="bold-text">{experience.year}</p>
							</div>
							<motion.div className="app__skills-exp-works">
								{experience.works.map((work) => (
									<div key={work._key}>
										<motion.div
											whileInView={{ opacity: [0, 1] }}
											transition={{ duration: 0.5 }}
											className="app__skills-exp-work"
											data-tip
											data-for={work.name}>
											<h4 className="bold-text">{work.name}</h4>
											<p className="p-text">{work.company}</p>
										</motion.div>
										<ReactTooltip
											id={work.name}
											effect="solid"
											arrowColor="#fff"
											className="skills-tooltip">
											{work.desc}
										</ReactTooltip>
									</div>
								))}
							</motion.div>
						</motion.div>
					))} */}

					<motion.div className="app__skills-exp-item" >
						<div className="app__skills-exp-year">
							<p className="bold-text">2022</p>
						</div>
						<motion.div className="app__skills-exp-works">
							<div>
								<motion.div
									whileInView={{ opacity: [0, 1] }}
									transition={{ duration: 0.5 }}
									className="app__skills-exp-work"
									data-tip
									data-for="Frontend Developer">
									<h4 className="bold-text">Mern Stack Developer</h4>
									<p className="p-text">Ghani Business Solution</p>
								</motion.div>
								<ReactTooltip
									id={"Frontend Developer"}
									effect="solid"
									arrowColor="#fff"
									className="skills-tooltip">
									I worked as a Junior Mern stack Developer
								</ReactTooltip>
							</div>
							<div>
								<motion.div
									whileInView={{ opacity: [0, 1] }}
									transition={{ duration: 0.5 }}
									className="app__skills-exp-work"
									data-tip
									data-for="Frontend Internship">
									<h4 className="bold-text">Frontend Internship</h4>
									<p className="p-text">Interns Pakistan</p>
								</motion.div>
								<ReactTooltip
									id={"Frontend Internship"}
									effect="solid"
									arrowColor="#fff"
									className="skills-tooltip">
									Learned in a fast paced to get my basics straight.
								</ReactTooltip>
							</div>
						</motion.div>
					</motion.div>
				</div>
			</div>
		</>
	);
};

export default AppWrap(
	MotionWrap(Skills, "app__skills"),
	"skills",
	"app__whitebg"
);
